import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import ICustomer from '../../../_interfaces/ICustomer';
import ISite from '../../../_interfaces/ISite';
import { AuthenticationService } from '../../../_services/authentication/authentication.service';
import { SessionService } from '../../../_services/session/session.service';

@Component({
  standalone: true,
  selector: 'app-clinic-selector',
  templateUrl: './clinic-selector.component.html',
  styleUrls: ['./clinic-selector.component.scss'],
  imports: [CommonModule, TranslatePipe],
})
export class ClinicSelectorComponent implements OnInit {
  public loading = true;
  public switchingSiteId: number | null = null;
  public activeCustomer: ICustomer | null = null;
  public sites: ISite[] = [];

  constructor(
    private authService: AuthenticationService,
    private session: SessionService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.loadContext();
  }

  loadContext() {
    this.loading = true;
    this.authService.loadContext().subscribe({
      next: (context: any) => {
        const user = context?.user;
        if (user?.superuser && !context?.session?.is_acting) {
          this.router.navigate(['/administration/customers']);
          return;
        }

        const customers = context?.customers || [];
        const effectiveCustomerId = context?.session?.effective_customer_id;

        const scopedCustomer = effectiveCustomerId
          ? customers.find((customer) => +customer.id === +effectiveCustomerId)
          : null;

        this.activeCustomer =
          scopedCustomer || context?.activeCustomer || customers[0] || null;

        this.sites = this.activeCustomer?.sites || [];

        if (!this.sites.length) {
          this.router.navigate(['/context/no-clinics']);
          return;
        }

        if (this.sites.length === 1 && this.sites[0]?.id) {
          this.selectClinic(this.sites[0]);
          return;
        }

        this.loading = false;
      },
      error: () => {
        this.loading = false;
      },
    });
  }

  selectClinic(site: ISite) {
    if (!site?.id) return;
    this.switchingSiteId = +site.id;
    this.authService.switchClinic(+site.id).subscribe({
      next: () => {
        this.switchingSiteId = null;
        this.router.navigate(['/entry']);
      },
      error: () => {
        this.switchingSiteId = null;
      },
    });
  }

  exitActingMode() {
    this.authService.exitActingCustomer().subscribe({
      next: () => {
        this.router.navigate(['/administration/customers']);
      },
    });
  }

  get isActingSuperadmin(): boolean {
    return this.session.isSuperUser() && this.session.isActingContext();
  }

  get canOpenAdministration(): boolean {
    if (!this.activeCustomer) return false;
    return (
      this.session.isSuperUser() ||
      !!this.session.isCustomerAdmin(this.activeCustomer)
    );
  }

  openAdministration(): void {
    if (!this.activeCustomer?.id) return;
    this.router.navigate([
      '/administration',
      this.activeCustomer.identifier || this.activeCustomer.id,
      'users',
    ]);
  }
}
